export enum BOT_CHAT {
  EVENT_ADMIN = "https://nubi.city/bot/a",
  EVENT_USER = "https://nubi.city/bot/u",
  OFFICE_ADMIN = "https://nubi.city/bot/oa",
  OFFICE_USER = "https://nubi.city/bot/ou",
  FEEDBACK_USER = "https://nubi.city/bot/i",
  INVITE_USER = "https://nubi.city/bot/y",
}
